var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreditionZeilenabstandControl(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.19,8.06a1.43,1.43,0,0,1,0-2L44.79.41a1.39,1.39,0,0,1,1.6-.27A1.41,1.41,0,0,1,47,.48l5.61,5.64a1.43,1.43,0,0,1,0,2,1.41,1.41,0,0,1-1,.42,1.38,1.38,0,0,1-1-.42L47.34,4.87v8.72a1.42,1.42,0,1,1-2.83,0V4.71L41.19,8.06a1.41,1.41,0,0,1-1,.42A1.39,1.39,0,0,1,39.19,8.06Zm11.4,19.87-3.33,3.35V22.4a1.42,1.42,0,1,0-2.83,0v8.73l-3.24-3.27a1.4,1.4,0,0,0-2,0,1.43,1.43,0,0,0,0,2l5.6,5.64a1.47,1.47,0,0,0,.59.34,1.35,1.35,0,0,0,1.6-.27l5.61-5.64a1.43,1.43,0,0,0,0-2A1.4,1.4,0,0,0,50.59,27.93ZM27.84.37H1.41a1.42,1.42,0,0,0,0,2.84H27.84a1.42,1.42,0,1,0,0-2.84Zm0,10.82H1.41a1.43,1.43,0,0,0,0,2.85H27.84a1.43,1.43,0,0,0,0-2.85Zm0,10.83H1.41a1.43,1.43,0,0,0,0,2.85H27.84a1.43,1.43,0,0,0,0-2.85Zm0,10.83H1.41a1.42,1.42,0,0,0,0,2.84H27.84a1.42,1.42,0,0,0,0-2.84Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreditionZeilenabstandControl);
export default __webpack_public_path__ + "static/media/tredition-zeilenabstand-control.f26856a2af607f2761b71036f222cd48.svg";
export { ForwardRef as ReactComponent };